import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e21e418"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-inner-card card px-5 py-2 is-flex" }
const _hoisted_2 = {
  key: 0,
  class: "currency-backend error-msg"
}
const _hoisted_3 = {
  key: 1,
  class: "currency-backend"
}
const _hoisted_4 = { class: "is-align-items-center is-flex bal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["currency", { active: _ctx.isCurrencySelected }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCurrencySelected || _ctx.$emit('currencySelected', _ctx.currency)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["is-flex-grow-1 currency-name", { unavailable: _ctx.name === null }])
      }, [
        _createTextVNode(_toDisplayString(_ctx.name || _ctx.$gettext("unavailable")) + " ", 1),
        (_ctx.isTemporarilyUnavailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$gettext("Temporarily unavailable - please refresh")), 1))
          : _createCommentVNode("", true),
        (_ctx.showAccountId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$gettext("as %{ id }", { id: _ctx.currency?.internalId })), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: _normalizeClass(["currency-supply", { unavailable: _ctx.supply === null }])
        }, [
          (_ctx.supply !== null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.numericFormat(parseFloat(_ctx.supply))), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.numericPlaceholder(10000000)), 1)
              ], 64))
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass(["currency-symbol", { unavailable: _ctx.symbol === null }])
        }, _toDisplayString(_ctx.symbol || "???"), 3),
        (!_ctx.disableDropDown)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass({
            hide:
              !_ctx.isCurrencySelected ||
              _ctx.$dropdownMenu.listItems(_ctx.currency).length === 0,
          })
            }, [
              _createVNode(_component_DropdownMenu, { object: _ctx.currency }, null, 8, ["object"])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}